define('views/presence/Podio.Views.Presence.UserListModal',['require','jquery','underscore','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','jst!presence/user_list_modal/_user','jst!presence/user_list_modal/_modal'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');
  var ViewPodioBase = require('lib/backbone/Backbone.PodioView');
  var modal = require('lib/Podio.UI.Modal');

  var jstUser = require('jst!presence/user_list_modal/_user');
  var jstModal = require('jst!presence/user_list_modal/_modal');

  return ViewPodioBase.extend({

    initialize: function( options ) {
      _.bindAll(this, 'render', 'onModalHidden');

      this.title = this.options.title;

      this._super();
    },

    render: function() {

      var usersHtml = this.collection.map(function(item) {
        return this.getTemplate(jstUser, {
          user: item
        });
      }, this);

      this.elm.html(this.getTemplate(jstModal, {
        users: usersHtml.join('')
      }));

      modal.show(this.elm.html(), {
        title: this.title,
        className : 'user-list-modal',
        hideHandler: this.onModalHidden
      });

      $('.user-list-modal .user-list').css('maxHeight', modal.availableHeight());

    },

    onModalHidden: function() {
      this.dispose();
      return true;
    }

  });

});

